"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unfoldFormatClazz = void 0;
const core_1 = require("../core");
const isIdentifier_1 = require("../utils/isIdentifier");
function unfoldFormatClazz(clazz) {
    switch (clazz["@kind"]) {
        case "ClazzNull": {
            return { bindings: [] };
        }
        case "ClazzCons": {
            const propertyType = (0, core_1.formatCore)(clazz.propertyType);
            const key = clazz.propertyName === clazz.localName
                ? formatName(clazz.propertyName)
                : `${formatName(clazz.propertyName)} [rename: ${formatName(clazz.localName)}]`;
            const binding = `${key}: ${propertyType}`;
            const { bindings } = unfoldFormatClazz(clazz.rest);
            return { bindings: [binding, ...bindings] };
        }
        case "ClazzFulfilled": {
            const propertyType = (0, core_1.formatCore)(clazz.propertyType);
            const property = (0, core_1.formatCore)(clazz.property);
            const key = formatName(clazz.propertyName);
            const binding = `${key}: ${propertyType} = ${property}`;
            const { bindings } = unfoldFormatClazz(clazz.rest);
            return { bindings: [binding, ...bindings] };
        }
    }
}
exports.unfoldFormatClazz = unfoldFormatClazz;
function formatName(name) {
    return (0, isIdentifier_1.isIdentifier)(name) ? name : `"${name}"`;
}
//# sourceMappingURL=unfoldFormatClazz.js.map